"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialArchive = void 0;
class MaterialArchive {
    static init() {
        const archive = document.querySelector('.term-materialen');
        if (archive === undefined || archive === null) {
            return;
        }
        const filterLinks = document.querySelectorAll('#sidebar-shop .woocommerce-widget-layered-nav-list a');
        if (filterLinks === undefined || filterLinks === null) {
            return;
        }
        filterLinks.forEach((item) => {
            let link = item.getAttribute('href');
            link += '#archive-products';
            if (link !== null) {
                item.setAttribute('href', link);
            }
        });
    }
}
exports.MaterialArchive = MaterialArchive;
